import React from 'react'
import { Routes } from './routes'

function App(): React.ReactElement {
    return <Routes />
}

export default App
